'use client';

import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { SVT_CORNER, SVT_FOCUS_RING } from '@eliadmin/core/src/components/ui/svetech-shape';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/*
 * SveTech switcher (Key design „Taby“, same as `svetech/home/filling-tabs`): #f2f3ef bar with the
 * radius 15 → 20 px and the square top-right corner, the active tab white.
 */

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center gap-1.5 bg-[#f2f3ef] p-1.5 text-[#4a5560] [--svt-radius:15px] lg:[--svt-radius:20px]',
      SVT_CORNER,
      className,
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'svt-button inline-flex items-center justify-center whitespace-nowrap px-5 py-3.5 transition-[color,background-color,box-shadow] [--svt-radius:12px] hover:text-[#14171a] disabled:pointer-events-none disabled:opacity-70 motion-reduce:transition-none lg:[--svt-radius:15px]',
      SVT_CORNER,
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#2c7a25]',
      'data-[state=active]:bg-white data-[state=active]:text-[#14171a] data-[state=active]:shadow-[0_4px_16px_rgba(13,26,13,0.1)]',
      className,
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content ref={ref} className={cn('mt-2', SVT_FOCUS_RING, className)} {...props} />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
